<template>
<div class="py-2 bg-white b-b-2 b-r-2 b-l-2">
    <AccordionCollapse collapsed shadow title="کمیسیون پیش‌فرض" v-if="defaultCommission">
        <CRow>
            <CCol col="12">
                <span class="d-block font-sm">
                    در ازای خرید: {{ defaultCommission.sale.action_value }} {{ defaultCommission.sale.action_type === 0 ? 'درصد' : 'ریال' }}
                </span>
                <span class="d-block font-sm">
                    در ازای لید: {{ defaultCommission.lead.action_value }} {{ defaultCommission.lead.action_type === 0 ? 'درصد' : 'ریال' }}
                </span>
            </CCol>
        </CRow>
    </AccordionCollapse>

    <AccordionCollapse collapsed shadow title="گروه کمیسیونی شما" v-if="Object.keys(groups).length > 0">
        <CRow>
            <CCol col="12" v-for="(group, index) in groups" :key="index">
                <h5>{{ group.name }}</h5>
                <span class="d-block font-sm">
                    در ازای خرید: {{ group.sale.action_value }} {{ group.sale.action_type === 0 ? 'درصد' : 'ریال' }}
                </span>
                <span class="d-block font-sm">
                    در ازای لید: {{ group.lead.action_value }} {{ group.lead.action_type === 0 ? 'درصد' : 'ریال' }}
                </span>
            </CCol>
        </CRow>
    </AccordionCollapse>

    <AccordionCollapse collapsed shadow title="کمیسیون پلکانی" v-if="Object.keys(tiers).length > 0">
        <CRow>
            <CCol col="12" v-for="(tier, index) in tiers" :key="'tier-'+index">
                <p class="font-sm" v-for="(metric, metIndex) in tier.metrics" :key="'metric-'+metIndex">
                    در صورتی که {{ commissionMetricBaseStr(tier.base) }} بزرگتر مساوی
                    <span class="badge badge-affili-golden-tainoi">{{ metric.gte }}</span>
                    شود؛ مقدار کمیسیون
                    <span v-if="tier.tier_type === CommissionTierType.FIXED">برابر با</span>
                    {{ commissionTierTypeStr(tier.tier_type) }}
                    <span class="badge badge-affili-golden-tainoi">{{ metric.tier_value }}</span>
                    خواهد شد.
                </p>
                <p v-for="(metric, index) in tier.metrics" :key="index">

                </p>
            </CCol>
        </CRow>
    </AccordionCollapse>

    <AccordionCollapse collapsed shadow title="قوانین کمیسیون عمومی" v-if="Object.keys(globalRules).length > 0">
        <CRow>
            <CCol col="12" v-for="rule in globalRules" :key="rule.id" class="bg-gray-100 text-dark mb-2 pt-2" style="border-radius: 5px">
                <h5 class="d-inline-block mfe-2">{{ rule.name }}:</h5>
                <span v-html="rule.description.replace(/(?:\r\n|\r|\n)/g, '<br />')"></span>
                <!-- <span class="d-inline-block">
                    {{ actionTypeStr(rule.action_type) }}: {{ rule.action_value }}
                </span> -->
                <!-- <div v-if="rule.description">
                    <span class="d-inline-block mfe-1">توضیحات:</span>
                    <span v-html="rule.description.replace(/(?:\r\n|\r|\n)/g, '<br />')"></span>
                </div> -->
                <!-- <div>
                    شرایط:
                    <ul>
                        <li v-for="(condition, index) in rule.conditions" :key="index">
                            {{ ruleConditionSentence(condition) }}
                        </li>
                    </ul>
                </div> -->
            </CCol>
        </CRow>
    </AccordionCollapse>
    <AccordionCollapse collapsed shadow title="قوانین کمیسیون اختصاصی شما" v-if="Object.keys(individualRules).length > 0">
        <CRow>
            <CCol col="12" v-for="rule in individualRules" :key="rule.id" class="bg-gray-100 text-dark mb-2 pt-2" style="border-radius: 5px">
                <h5 class="d-inline-block mfe-2">{{ rule.name }}:</h5>
                <span v-html="rule.description.replace(/(?:\r\n|\r|\n)/g, '<br />')"></span>

                <!-- <span class="d-inline-block">
                    {{ actionTypeStr(rule.action_type) }}: {{ rule.action_value }}
                </span>
                <div v-if="rule.description">
                    <span class="d-inline-block mfe-1">توضیحات:</span>
                    <span v-html="rule.description.replace(/(?:\r\n|\r|\n)/g, '<br />')"></span>
                </div>
                <div>
                    شرایط:
                    <ul>
                        <li v-for="(condition, index) in rule.conditions" :key="index">
                            {{ ruleConditionSentence(condition) }}
                        </li>
                    </ul>
                </div> -->
            </CCol>
        </CRow>
    </AccordionCollapse>

    <AccordionCollapse collapsed shadow title="کمیسیون دسته‌بندی‌های خاص" v-if="Object.keys(categoryBaseCommissions).length > 0">
        <div v-for="({product_groups}, index) in categoryBaseCommissions" :key="index">
            <div v-for="(product_group, index) in product_groups" :key="index">
                {{ product_group.meta.name }}: {{ product_group.sale.action_value }} {{ product_group.sale.action_type == CommissionActionType.SET_PERCENTAGE ? $t('percent') : $t('rial') }}
            </div>
        </div>
    </AccordionCollapse>

    <AccordionCollapse collapsed shadow title="کمیسیون محصولات خاص" v-if="Object.keys(productBaseCommissions).length > 0">
        <div v-for="({products}, index) in productBaseCommissions" :key="index">
            <div v-for="(product, index) in products" :key="index">
                {{ product.meta.name }}: {{ product.sale.action_value }} {{ product.sale.action_type == CommissionActionType.SET_PERCENTAGE ? $t('percent') : $t('rial') }}
            </div>
        </div>
    </AccordionCollapse>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import AccordionCollapse from '@/components/AccordionCollapse'
import { firstIndex } from '@/common/objects'
import { actionTypeStr, ruleConditionSentence } from './methods'
import { commissionMetricBaseStr, commissionTierTypeStr } from './methods'
import { CommissionTierType, CommissionActionType } from '@/constants'

export default {
    name: 'Table',

    components: {
        AccordionCollapse
    },

    data() {
        return {
            CommissionTierType,
            CommissionActionType,
        }
    },

    computed: {
        ...mapGetters({
            storeById: 'store/storeById',
            defaults: 'v2commission/defaults',
            groups: 'v2commission/groups',
            globalCommissionRules: 'v2commission/globalCommissionRules',
            individualCommissionRules: 'v2commission/individualCommissionRules',
            tiers: 'v2commission/tiers',
            categoryBaseCommissions: 'v2commission/categoryBaseCommissions',
            productBaseCommissions: 'v2commission/productBaseCommissions',
        }),
        defaultCommission() {
            return firstIndex(this.defaults)
        },
        globalRules() {
            const commission = firstIndex(this.globalCommissionRules)

            return commission ? commission.rules : {}
        },
        individualRules() {
            const commission = firstIndex(this.individualCommissionRules)

            return commission ? commission.rules : {}
        },
    },

    methods: {
        actionTypeStr,
        ruleConditionSentence,
        commissionMetricBaseStr,
        commissionTierTypeStr,
    }
}
</script>